//GET_USER_LOG
export const GET_USER_LOG_REQUEST = "GET_USER_LOG_REQUEST";
export const GET_USER_LOG_SUCCESS = "GET_USER_LOG_SUCCESS";
export const GET_USER_LOG_FAIL = "GET_USER_LOG_FAIL";
